import { render } from "./CustomerService.vue?vue&type=template&id=335aa20a"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__